import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { Cookies } from '../../index.js';
import { ClipLoader } from 'react-spinners';

const Description = ({ partnerUsername }) => {
    const { slug_1, slug_2, slug_3, slug_4 } = useParams();

    const [users, set_users] = useState('');

    const laythongtin = (data) => {
        axios
            .post('https://hust.media/api/profile/profile.php', data)
            .then(response => set_users(response.data))
            .catch(error => console.log(123 + error));
    };

    useEffect(() => {
        const normalizedPartner = String(partnerUsername || '').trim();
        set_users('');
        if (normalizedPartner) {
            laythongtin({
                partner_usersname: normalizedPartner,
                chedo: 'partner_profile',
            });
            return;
        }
        const slugs = [slug_1, slug_2, slug_3, slug_4];
        const numericSlug = slugs.find(value => /^\d+$/.test(String(value)));
        if (!numericSlug) {
            return;
        }
        if (slug_3 == 'shop') {
            // nếu là play thì gửi partner_profile_id
            laythongtin({
                partner_profile_id: slug_4,
                chedo: 'partner_profile',
            });
        } else {
            // còn lại thì gửi apikey
            const apiKey = Cookies.get('apikey');
            laythongtin({
                apikey: apiKey,
                chedo: 'partner_profile',
            });
        }
    }, [partnerUsername, slug_1, slug_2, slug_3, slug_4]); // chỉ chạy khi đổi nguồn dữ liệu

    return (
        <>
            {!users &&
                (<>
                    <div style={{ textAlign: "center" }} className="mt-4 justify-center items-center">
                        <ClipLoader color="#fff" size={150} />
                    </div>
                </>)}
            {users &&
                (
                    <>
                        <div className='px-1 py-3 bg-slate-100 mt-2'>
                            <h5>Mô tả người dùng</h5>
                            {users.username && (
                                <div className='flex items-center gap-2 text-base lg:text-lg'>
                                    <svg
                                        xmlns='http://www.w3.org/2000/svg'
                                        fill='none'
                                        viewBox='0 0 24 24'
                                        strokeWidth={1.5}
                                        stroke='currentColor'
                                        className='w-4 h-4'>
                                        <path
                                            strokeLinecap='round'
                                            strokeLinejoin='round'
                                            d='M15.75 7.5a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.5 20.118a7.5 7.5 0 0115 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.5-1.632z'
                                        />
                                    </svg>
                                    <span className='min-w-[110px] lg:min-w-[200px]'>Username</span>
                                    <span>{users.username}</span>
                                </div>
                            )}
                            {users.money && (
                                <div className='flex items-center gap-2 text-base lg:text-lg'>
                                    <svg
                                        xmlns='http://www.w3.org/2000/svg'
                                        fill='none'
                                        viewBox='0 0 24 24'
                                        strokeWidth={1.5}
                                        stroke='currentColor'
                                        className='w-4 h-4'>
                                        <path
                                            strokeLinecap='round'
                                            strokeLinejoin='round'
                                            d='M12 6v12m6-6H6'
                                        />
                                    </svg>
                                    <span className='min-w-[110px] lg:min-w-[200px]'>Số dư</span>
                                    <span>{users.money}</span>
                                </div>
                            )}
                            {users.chietkhau && (
                                <div className='flex items-center gap-2 text-base lg:text-lg'>
                                    <svg
                                        xmlns='http://www.w3.org/2000/svg'
                                        fill='none'
                                        viewBox='0 0 24 24'
                                        strokeWidth={1.5}
                                        stroke='currentColor'
                                        className='w-4 h-4'>
                                        <path
                                            strokeLinecap='round'
                                            strokeLinejoin='round'
                                            d='M9 12h.01M15 12h.01M8.25 6.75l7.5 10.5M4.5 7.5a6.75 6.75 0 0110.802-5.284M19.5 16.5a6.75 6.75 0 01-10.802 5.284'
                                        />
                                    </svg>
                                    <span className='min-w-[110px] lg:min-w-[200px]'>Chiết khấu</span>
                                    <span>{users.chietkhau}</span>
                                </div>
                            )}
                            {users.total_nap && (
                                <div className='flex items-center gap-2 text-base lg:text-lg'>
                                    <svg
                                        xmlns='http://www.w3.org/2000/svg'
                                        fill='none'
                                        viewBox='0 0 24 24'
                                        strokeWidth={1.5}
                                        stroke='currentColor'
                                        className='w-4 h-4'>
                                        <path
                                            strokeLinecap='round'
                                            strokeLinejoin='round'
                                            d='M12 6v12m6-6H6'
                                        />
                                    </svg>
                                    <span className='min-w-[110px] lg:min-w-[200px]'>Tổng nạp</span>
                                    <span>{users.total_nap}</span>
                                </div>
                            )}
                            {users.namelevel && (
                                <div className='flex items-center gap-2 text-base lg:text-lg'>
                                    <svg
                                        xmlns='http://www.w3.org/2000/svg'
                                        fill='none'
                                        viewBox='0 0 24 24'
                                        strokeWidth={1.5}
                                        stroke='currentColor'
                                        className='w-4 h-4'>
                                        <path
                                            strokeLinecap='round'
                                            strokeLinejoin='round'
                                            d='M12 3.75l2.318 4.695 5.182.754-3.75 3.655.886 5.166L12 15.75l-4.636 2.44.886-5.166-3.75-3.655 5.182-.754L12 3.75z'
                                        />
                                    </svg>
                                    <span className='min-w-[110px] lg:min-w-[200px]'>Cấp độ</span>
                                    <span>{users.namelevel}</span>
                                </div>
                            )}
                            {users.phone && (
                                <div className='flex items-center gap-2 text-base lg:text-lg'>
                                    <svg
                                        xmlns='http://www.w3.org/2000/svg'
                                        fill='none'
                                        viewBox='0 0 24 24'
                                        strokeWidth={1.5}
                                        stroke='currentColor'
                                        className='w-4 h-4'>
                                        <path
                                            strokeLinecap='round'
                                            strokeLinejoin='round'
                                            d='M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 002.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 01-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 00-1.091-.852H4.5A2.25 2.25 0 002.25 4.5v2.25z'
                                        />
                                    </svg>
                                    <span className='min-w-[110px] lg:min-w-[200px]'>Số điện thoại</span>
                                    <span>{users.phone}</span>
                                </div>
                            )}
                            {users.email && (
                                <div className='flex items-center gap-2 text-base lg:text-lg'>
                                    <svg
                                        xmlns='http://www.w3.org/2000/svg'
                                        fill='none'
                                        viewBox='0 0 24 24'
                                        strokeWidth={1.5}
                                        stroke='currentColor'
                                        className='w-4 h-4'>
                                        <path
                                            strokeLinecap='round'
                                            strokeLinejoin='round'
                                            d='M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75'
                                        />
                                    </svg>
                                    <span className='min-w-[110px] lg:min-w-[200px]'>Email</span>
                                    <span>{users.email}</span>
                                </div>
                            )}
                            {users.createdate && (
                                <div className='flex items-center gap-2 text-base lg:text-lg'>
                                    <svg
                                        xmlns='http://www.w3.org/2000/svg'
                                        fill='none'
                                        viewBox='0 0 24 24'
                                        strokeWidth={1.5}
                                        stroke='currentColor'
                                        className='w-4 h-4'>
                                        <path
                                            strokeLinecap='round'
                                            strokeLinejoin='round'
                                            d='M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z'
                                        />
                                    </svg>
                                    <span className='min-w-[110px] lg:min-w-[200px]'>Ngày mở TK</span>
                                    <span>{users.createdate}</span>
                                </div>
                            )}
                        </div>
                    </>
                )

            }
        </>


    )
}

export default Description
